import { render, staticRenderFns } from "./ResultsSearch.vue?vue&type=template&id=3a4d9c9a&scoped=true"
import script from "./ResultsSearch.vue?vue&type=script&lang=js"
export * from "./ResultsSearch.vue?vue&type=script&lang=js"
import style0 from "./ResultsSearch.vue?vue&type=style&index=0&id=3a4d9c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d9c9a",
  null
  
)

export default component.exports